import styles from './Marketplace.module.scss';

export default function Marketplace() {
    return (
        <div className={styles.marketplace_container}>
            <iframe title="Loja Bitrix" src="https://b24-njekse.bitrix24.site" />
        </div>
    );
}
